import React, { createContext, useContext, useMemo } from 'react';

export interface ShellScrollState {
  hidden: boolean;
  scrolled: boolean;
}

const ShellScrollContext = createContext<ShellScrollState>({ hidden: false, scrolled: false });

export const ShellScrollProvider: React.FC<
  ShellScrollState & { children: React.ReactNode }
> = ({ hidden, scrolled, children }) => {
  const value = useMemo(() => ({ hidden, scrolled }), [hidden, scrolled]);
  return <ShellScrollContext.Provider value={value}>{children}</ShellScrollContext.Provider>;
};

export const useShellScroll = (): ShellScrollState => useContext(ShellScrollContext);
